$(document).ready(function(){
    'use strict'

    //Функция раскрытия вопроса
    function showQuestion(questionBlock) {
        questionBlock.find('.questions1__plus').toggleClass('active');
        questionBlock.find('.questions1__answer').slideToggle();
    }

    //Добавление обработчиков клика для показа вопроса
    $('.questions1__box').on('click', function () {
        const questionBlock = $(this).parents('.questions1__item');

        showQuestion(questionBlock);
    });

    //Переключение лайков
    const questionStatusNode = $('.questions1__likes-status');

    questionStatusNode.on('click', function () {
        const statusesNode = $(this).parents('.questions1__likes-statuses');
        const allStatus = statusesNode.find('.questions1__likes-status');

        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            allStatus.removeClass('active')
            $(this).addClass('active');
        }

    });

    //ОТКРЫТИЕ ВОПРОСА ПО КЛИКУ НА ССЫЛКУ В ДРУГОМ ВОПРОСЕ
    $('.js-open-question').on('click', function(){
    	let questionCollection = $('.questions1__list')
		let questionNumber = +$(this).attr('data-question') - 1
		let questionBlock = questionCollection.find(`.questions1__item:eq(${questionNumber})`);
		showQuestion(questionBlock)
	})
});
